import { useEffect, useState } from 'react';
import { fetchSpinWheelEnabled, subscribeSpinWheel } from '../lib/siteSettings';

/**
 * Returns whether the Spin & Win feature is currently enabled.
 * While loading it returns `null` so callers can avoid flicker.
 */
export function useSpinWheelEnabled(): boolean | null {
  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchSpinWheelEnabled().then((v) => {
      if (!cancelled) setEnabled(v);
    });

    // Listen for admin toggle changes within the same session
    const unsub = subscribeSpinWheel((v) => {
      if (!cancelled) setEnabled(v);
    });

    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  return enabled;
}
